const styles = {
  root: {
    padding: 1,
    borderBottom: 1,
    borderColor: 'background.border',
  },
  imageContainer: {
    maxWidth: '40px!important',
    width: '40px!important',
    marginRight: 1,
  },
  noImage: {
    position: 'relative',
    borderRadius: 1,
    border: '1px solid #ececec',
    width: '100%',
    minHeight: '100%',
    height: '40px!important',
    '& img': {
      borderRadius: 1,
    },
  },
  vehicleText: {
    fontSize: '12px!important',
    fontWeight: '600!important',
    '& span': {
      margin: { xs: '2px', sm: 0.5 },
    },
  },
  priceText: {
    marginTop: 0.5,
  },
}

export default styles
